import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SectionsUIHelpers";

const SectionsUIContext = createContext();

export function useSectionsUIContext() {
  return useContext(SectionsUIContext);
}

export const SectionsUIConsumer = SectionsUIContext.Consumer;

export function SectionsUIProvider({ sectionsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openStudentAbsenteeismsPage: sectionsUIEvents.openStudentAbsenteeismsPage
  };

  return (
    <SectionsUIContext.Provider value={value}>
      {children}
    </SectionsUIContext.Provider>
  );
}